import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { BlobProvider } from '@react-pdf/renderer';
import print from 'print-js';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';
import UmslagToPdf from "./UmslagToPdf";


const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing()
  }
}));

const UmslagPrint = ({ kjosandi, activeKosning }) => {
  const classes = useStyles();

  // Works in Chrome, Edge Chromium
  // Atm, Firefox opens the pdf in a new tab
  // Broken in MS Edge (Access denied)
  const handlePrint = url => e => {
    print(url, 'pdf')
  }

  return (
    <BlobProvider
      document={
        <UmslagToPdf kjosandi={kjosandi} activeKosning={activeKosning} />
      }
    >
      {({ url }) => (
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handlePrint(url)}
        >
          <PrintIcon className={classes.icon} />
          Prenta umslag
        </Button>
      )}
    </BlobProvider>
  );
}

export default UmslagPrint;